<script lang="ts" setup>
import { ref, onMounted, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import KWRevolution from '@/assets/menu/kw_revolution.jpg';
import Wolverine from '@/assets/menu/wolverine.jpg';
import Circular from '@/assets/menu/circular.jpg';
import Telephoto from '@/assets/menu/telephoto.jpg';
import DropIn from '@/assets/menu/dropin.jpg';
import Special from '@/assets/menu/special.jpg';
import Armour100 from '@/assets/menu/armour-100.jpg';
import Wolverine100 from '@/assets/menu/wolverine-100.jpg';
import Armour150 from '@/assets/menu/armour-150.jpg';
import Wolverine150 from '@/assets/menu/wolverine-150.jpg';
import Wolverine75 from '@/assets/menu/wolverine-75.jpg'
import Clipin from '@/assets/menu/clipin.jpg';
import Rear from '@/assets/menu/rear.jpg';
import Drone from '@/assets/menu/drone.jpg';
import MovieMate from '@/assets/menu/moviemate.jpg';
import CinemaFilter from '@/assets/menu/cinema-filter.jpg';
import CinemaCircular from '@/assets/menu/cinema-circular.jpg';
import CinemaStackable from '@/assets/menu/cinema-stackable.jpg';
import VND from '@/assets/menu/vnd.jpg';
import SmartphoneCase from '@/assets/menu/smartphone-case.jpg';
import SmartphoneFilter from '@/assets/menu/smartphone-filter.jpg';
import SmartphoneLens from '@/assets/menu/smartphone-lens.jpg';
import SmartphoneKit from '@/assets/menu/smartphone-kit.jpg';
import FujiG from '@/assets/menu/fuji-g.jpg';
import FujiX from '@/assets/menu/fuji-x.jpg';
import NikonZ from '@/assets/menu/nikon-z.jpg';
import SonyE from '@/assets/menu/sony-e.jpg';
import CanonEF from '@/assets/menu/canon-ef.jpg';
import CanonRF from '@/assets/menu/canon-rf.jpg';
import CloseUp from '@/assets/menu/Close-up-lens.jpg';

import { useRoute } from 'vue-router'

import messages from './locales/messages';


const { t, locale } = useI18n({
    useScope: 'global',
    locale: 'fr',
    fallbackLocale: 'fr',
    messages
})
const route = useRoute()
const menu = ref([]);
function define_menu(){
    menu.value=[
    {
        title: t('menu.circulaires.title'),
        to: `/${locale.value}/category/circular`,
        children:[
            {
                title: t('menu.circulaires.revolution'),
                to: `/${locale.value}/category/circular/magnetic`,
                img: KWRevolution,
                children:[
                    {
                        title: t('menu.kits'),
                        to: `/${locale.value}/category/circular/magnetic/filters-kit`
                    },
                    {
                        title: t('menu.filtre_unit'),
                        to: `/${locale.value}/category/circular/magnetic/single-filters`
                    },
                    {
                        title: t('menu.filtre_effect'),
                        to: `/${locale.value}/category/circular/magnetic/effects-filters`
                    },
                    {
                        title: t('menu.magnetic_ring'),
                        to: `/${locale.value}/category/circular/magnetic/adapter-rings`
                    },
                    {
                        title: t('menu.accessories'),
                        to: `/${locale.value}/category/circular/magnetic/accessories`
                    }
                ]
            },/*
            {
                title: "Wolverine Magnétique",
                to: "/circulaires/wolverine_magnetique",
                img: Wolverine,
                children:[
                    {
                        title: "Kits de filtres",
                        to: "/circulaires/wolverine_magnetique/kit_filtres"
                    },
                    {
                        title: "Filtres à l'unité",
                        to: "/circulaires/wolverine_magnetique/filtres_unite"
                    },
                    {
                        title: "Filtres à effets",
                        to: "/circulaires/wolverine_magnetique/filtres_effets"
                    },
                    {
                        title: "Bagues magnétiques",
                        to: "/circulaires/wolverine_magnetique/bagues_magnetiques"
                    },
                    {
                        title: "Accessoires",
                        to: "/circulaires/wolverine_magnetique/accessoires"
                    }
                ]
            },*/
            {
                title: t('menu.circulaires.screw'),
                to: `/${locale.value}/category/circular/screw`,
                img: Circular,
                children:[
                    {
                        title: t('menu.filtre_unit'),
                        to:  `/${locale.value}/category/circular/screw/single-filters`
                    },
                    /*
                    {
                        title: t('menu.filtre_effect'),
                        to: `/${locale.value}/category/circular/screw/effects-filters`
                    },
                    */
                   {
                        "title": "Fujifilm X100VI",
                        "to": `/${locale.value}/category/circular/screw/fuji-x100vi`
                   },
                    {
                        title: t('menu.step_up_ring'),
                        to:  `/${locale.value}/category/circular/screw/step-up-rings`
                    }
                ]
            },
            {
                title: t('menu.circulaires.tele'),
                to: `/${locale.value}/category/circular/telephoto`,
                img: Telephoto,
                children:[
                    {
                        title: "Canon",
                        to: `/${locale.value}/product/Kase-MCUV-Kit-pour-Objectif-Canon-Series-Telephoto-Zoom_6923137707250`
                    },
                    {
                        title: "Nikon",
                        to: `/${locale.value}/product/Kase-MCUV-Kit-pour-Objectif-Nikon-Series-Telephoto-Zoom_0652733943842`
                    },
                    {
                        title: "Sony",
                        to: `/${locale.value}/product/Kase-MCUV-Kit-pour-Objectif-Sony-Series-Telephoto-Zoom_6923137707410`
                    },
                    
                ]
            }/*,
            {
                title: t('menu.circulaires.drop_in'),
                to: "/circulaires/dropin",
                img: DropIn,
                children:[
                    {
                        title: "Canon",
                        to: "/circulaires/dropin/canon"
                    },
                    {
                        title: "Nikon",
                        to: "/circulaires/dropin/nikon"
                    }
                ]

            },
            {
                title: t('menu.circulaires.specials'),
                to: "/circulaires/filtres_speciaux",
                img: Special,
                children:[
                    {
                        title: t('menu.specials.mirror'),
                        to: "/circulaires/filtres_speciaux/filtres_mirroir"
                    },
                    {
                        title: t('menu.specials.infrared'),
                        to: "/circulaires/filtres_speciaux/infrarouge"
                    },
                    {
                        title: t('menu.specials.streak_blue'),
                        to: "/circulaires/filtres_speciaux/streak_blue"
                    },
                    {
                        title: t('menu.specials.anti_fog'),
                        to: "/circulaires/filtres_speciaux/anti_fog"
                    },
                    {
                        title: t('menu.specials.variable_tone'),
                        to: "/circulaires/filtres_speciaux/variable_tone"
                    }
                ]
            }
                */
        ]
    },
    {
        title: t('menu.rectangulars.title'),
        to: `/${locale.value}/category/square`,
        children:[
            {
                title: t('menu.rectangulars.100mmArmour'),
                to: `/${locale.value}/category/square/100mm_armour_magnetic`,
                img: Armour100,
                children:[
                    {
                        title: t('menu.kits_holder'),
                        to: `/${locale.value}/category/square/100mm_armour_magnetic/kits-and-holders`
                    },
                    {
                        title: t('menu.circular_armour'),
                        to: `/${locale.value}/category/square/100mm_armour_magnetic/circular-armour-magnetic`
                    },
                    {
                        title: t('menu.filters_100mm'),
                        to: `/${locale.value}/category/square/100mm_armour_magnetic/100mm-filters`
                    },
                    {
                        title: t('menu.accessories'),
                        to: `/${locale.value}/category/square/100mm_armour_magnetic/accessories`
                    }
                ]
            },
            {
                title: '100mm Wolverine',
                to: `/${locale.value}/category/square/100mm_wolverine`,
                img: Wolverine100,
                children:[
                    {
                        title: t('menu.kits_holder'),
                        to: `/${locale.value}/category/square/100mm_wolverine/kits-and-holders`
                    },
                    {
                        title: t('menu.circular_k9'),
                        to: `/${locale.value}/category/square/100mm_wolverine/circular-k9-magnetic`
                    },
                    {
                        title: t('menu.filters_100mm'),
                        to: `/${locale.value}/category/square/100mm_wolverine/100mm-filters`
                    },
                    {
                        title: t('menu.accessories'),
                        to: `/${locale.value}/category/square/100mm_wolverine/accessories`
                    }
                ]
            },
            {
                title: t('menu.rectangulars.150mmK150'),
                to: `/${locale.value}/category/square/150mm_K150`,
                img: Armour150,
                children:[
                    {
                        title: t('menu.kits_holder'),
                        to: `/${locale.value}/category/square/150mm_K150/kits-and-holders`
                    },
                    {
                        title: t('menu.circular_k150'),
                        to: `/${locale.value}/category/square/150mm_K150/circular-k150-magnetic`
                    },
                    {
                        title: t('menu.filters_150mm'),
                        to: `/${locale.value}/category/square/150mm_K150/150mm-filters`
                    },
                    {
                        title: t('menu.accessories'),
                        to: `/${locale.value}/category/square/150mm_K150/accessories`
                    }
                ]
            },
            /*
            {
                title: '150mm Wolverine',
                to: `/${locale.value}/category/square/150mm_wolverine`,
                img: Wolverine150,
                children:[
                    {
                        title: t('menu.kits_holder'),
                        to: `/${locale.value}/category/square/150mm_wolverine/kits-and-holders`
                    },
                    {
                        title: t('menu.filters'),
                        to: `/${locale.value}/category/square/150mm_wolverine/filtres`
                    },
                    {
                        title: t('menu.accessories'),
                        to: `/${locale.value}/category/square/150mm_wolverine/accessories`
                    }
                ]
            }
            */
            /*,
            {
                title: '75mm Wolverine',
                to: '/rectangulaires/75mm_wolverine',
                img: Wolverine75,
                children:[
                    {
                        title: t('menu.holder_kits'),
                        to: '/rectangulaires/75mm_wolverine/kits'
                    },
                    {
                        title: t('menu.holders'),
                        to: '/rectangulaires/75mm_wolverine/porte_filtres'
                    },
                    {
                        title: t('menu.filters'),
                        to: '/rectangulaires/75mm_wolverine/filtres'
                    },
                    {
                        title: t('menu.accessories'),
                        to: '/rectangulaires/75mm_wolverine/accessoires'
                    }
                ]
            }
                */
        ]
    },
    {
        //title: 'Clip-in / Rear',
        title: 'Clip-in',
        to: `/${locale.value}/category/clipin-rear`,
        children: [
            {
                title: 'Clip-in',
                to: `/${locale.value}/category/clipin-rear`,
                img: Clipin,
                children: [
                    {
                        title: 'Sony',
                        to: `/${locale.value}/category/clipin-rear`
                    },
                    {
                        title: 'Canon',
                        to: `/${locale.value}/category/clipin-rear`
                    },
                    {
                        title: 'Nikon',
                        to: `/${locale.value}/category/clipin-rear`
                    },
                    {
                        title: 'Fuji',
                        to: `/${locale.value}/category/clipin-rear`
                    },
                    {
                        title: 'Panasonic',
                        to: `/${locale.value}/category/clipin-rear`
                    }
                ]
            }/*,
            {
                title: 'Rear',
                to: '/clipin-rear/rear',
                img: Rear,
                children: [
                    {
                        title: 'Sony',
                        to: '/clipin-rear/rear/sony'
                    },
                    {
                        title: 'Canon',
                        to: '/clipin-rear/rear/canon'
                    },
                    {
                        title: 'Nikon',
                        to: '/clipin-rear/rear/nikon'
                    },
                    {
                        title: 'Fuji',
                        to: '/clipin-rear/rear/fuji'
                    }
                ]
            }
                */
        ]
    },
    /*
    {
        title: t('menu.cinema_drone.title'),
        to: '/cinema-drone',
        children: [
            {
                title: t('menu.cinema_drone.drone'),
                to: '/cinema-drone/Drone',
                img: Drone,
                children: [
                    { 
                        title: 'DJI Mini 1 / 2 / 3 Pro / 4 Pro',
                        to: '/cinema-drone/drone/DJI-Mini'
                    },    
                    {
                        title: 'DJI Air 2 / 2S / 3',
                        to: '/cinema-drone/drone/DJI-Air'
                    },
                    {
                        title: 'DJI Mavic 2/ 3 / 3 Classic / 3 Pro',
                        to: '/cinema-drone/drone/DJI-Mavic'
                    },
                    {
                        title: 'DJI OSMO Pocket / Action',
                        to: '/cinema-drone/drone/DJI-OSMO'
                    },
                    
                ]
            },
            {
                title: 'Mattebox',
                to: '/cinema-drone/mattebox',
                img: MovieMate,
                children: [
                    {
                        title: t('menu.holder_kits'),
                        to: '/cinema-drone/mattebox/kit'
                    },
                    {
                        title: 'Mattebox',
                        to: '/cinema-drone/mattebox/mattebox'
                    },
                    {
                        title: t('menu.filters'),
                        to: '/cinema-drone/mattebox/filtres'
                    },
                    {
                        title: t('menu.accessories'),
                        to: '/cinema-drone/mattebox/accessoires'
                    },
                ]
            },
            {
                title: t('menu.cinema_drone.filtres4x565'),
                to: '/cinema-drone/filtre_4x5_65',
                img: CinemaFilter,
                children: [
                    {
                        title: t('menu.cinema_drone.slimfilters'),
                        to: '/cinema-drone/filtre_4x5_65/filtres_slim'
                    },
                    {
                        title: t('menu.cinema_drone.standardfilters'),
                        to: '/cinema-drone/filtre_4x5_65/porte-filtres'
                    },
                ]
            },
            {
                title: t('menu.cinema_drone.circulars'),
                to: '/cinema-drone/circulaires',
                img: CinemaCircular,
                children:[
                    {
                        title: t('menu.cinema_drone.for_movitematte'),
                        to: '/cinema-drone/circulaires/movie-mate'
                    }
                ]
            },
            {
                title: t('menu.cinema_drone.vnd'),
                to: '/cinema-drone/vnd_magnetiques',
                img: VND,
                children: [
                    {
                        title: t('menu.cinema_drone.vnd'),
                        to: '/cinema-drone/vnd_magnetiques/filtre_vnd',
                    },
                    {
                        title: t('menu.cinema_drone.vnd_magnetic'),
                        to: '/cinema-drone/vnd_magnetiques/porte-filtre',
                    },
                ]
            },
            {
                title: t('menu.cinema_drone.stackable'),
                to: '/cinema-drone/stackable',
                img: CinemaStackable,
                children: [
                    {
                        title: t('menu.cinema_drone.stackable_kit'),
                        to: '/cinema-drone/stackable/kit'
                    }
                ]
            }
        ]
    },
    */
    /*{
        title: t('menu.smartphone.title'),
        to: '/smartphone',
        children: [
            {
                title: t('menu.smartphone.holder_case'),
                to: '/smartphone/porte-filtres-coques',
                img: SmartphoneCase,
            },
            {
                title: t('menu.filters'),
                to: '/smartphone/filtres',
                img: SmartphoneFilter
            },
            {
                title: t('menu.smartphone.lenses'),
                to: '/smartphone/objectifs',
                img: SmartphoneLens,
            },
            {
                title: t('menu.holder_kits'),
                to: '/smartphone/kit',
                img: SmartphoneKit,
            }
        ]
    },*/
    {
        title: t('menu.lenses'),
        to: `/${locale.value}/category/lenses`,
        children: [
            {
                title: 'Reflex 200mm F5.6',
                to: `/${locale.value}/category/lenses`,
                img: SonyE,
                children:[
                    {
                        title: 'Sony E',
                        to: `/${locale.value}/product/KASE-Reflex-Lens---Sony-E-Mount-_6923137707595`
                    },
                    {
                        title: 'Canon RF',
                        to: `/${locale.value}/product/KASE-Reflex-Lens---Canon-RF-Mount-_6923137707601`
                    },
                    {
                        title: 'Canon EF',
                        to: `/${locale.value}/product/KASE-Reflex-Lens---Canon-EF-Mount-_6923137707588`
                    },
                    {
                        title:"Nikon Z",
                        to: `/${locale.value}/product/KASE-Reflex-Lens---Nikon-Z-Mount-_6923137707618`
                    },
                    {
                        "title": "Fuji G",
                        "to": `/${locale.value}/product/KASE-Reflex-Lens---Fuji-G-Mount-_6923137707632`
                    },
                    {
                        "title": "Fuji X",
                        "to": `/${locale.value}/product/KASE-Reflex-Lens---Fuji-X-Mount-_6923137707625`
                    },
                    {
                        "title": "Hasselblad XCD",
                        "to": `/${locale.value}/product/KASE-Reflex-Lens---Hasselblad-XCD-Mount-_6923137708189` 
                    }
                ]
            },
            {
                title: 'Lentille Macro',
                to: `/${locale.value}/product/Kase-Close-up-lens-set-77mm_6923137708646`,
                img: CloseUp,
                children:[
                    {
                        title: 'Lentille Macro 77mm',
                        to: `/${locale.value}/product/Kase-Close-up-lens-set-77mm_6923137708646`
                    }
                ]
            }
        ]
    },
    {
        title: "Drone",
        to: `/${locale.value}/category/drone`,
    },
    {
        title: t('menu.destockage'),
        to: `/${locale.value}/category/clearance`,
    }
];
}
// on locale change we need to update the menu
watch(locale,()=>{
    define_menu();
})
onMounted(()=>{
    define_menu();
})
</script>
<template>
    <ul class="nav">
        <li v-for="m in menu" :key="m.to" :class="{parent:m.children}">
            <router-link :to="m.to" :class="{'router-link-active': route.path.startsWith(m.to)}">{{m.title}}</router-link>
            
            <ul v-if="m.children">
                <li v-for="mm in m.children" :key="mm.to" :class="{parent:mm.children}">
                    <img class="menu" :src="mm.img" />
                    <router-link :to="mm.to">{{mm.title}}</router-link>
                    <ul v-if="mm.children">
                        <li v-for="mmm in mm.children" :key="mmm.to">
                            <router-link :to="mmm.to">{{mmm.title}}</router-link>
                        </li>
                    </ul>
                </li>
            </ul>
        </li>
    </ul>
</template>

<style lang="scss" scoped>
ul.nav{
    list-style-type: none;
    width: 100%;
    padding-left: 20px;
    li{
        text-transform: uppercase;
        font-weight: bold;
        color: #000;
        margin-top: 23px;
        &.parent{
            &>a:after{
                position: absolute;
                right: -15px;
                top: 0;
                content:'▸';
                text-decoration: none;
                color: #DC0303;
                transition: all .5s;
            }
            &>ul{
                display: block;
                
                list-style: none;
                max-height: 0;
                height: auto;
                transition: all .5s;
                overflow: hidden;
                &>li{
                    margin-top: 0;
                    padding-top: 13px;
                    padding-bottom: 15px;
                    padding-left: 90px;
                    background-position: left 5px;
                    background-size: auto 50px;
                    background-repeat: no-repeat;
                    position: relative;
                    img.menu{
                        position: absolute;
                        left: 3px;
                        width: 85px;
                        height: 62px;
                        object-fit: contain;

                    }
                    
                    /*
                    &#menu_filtres{
                        background-image: url(../assets/icons/Icone_Filtres.svg);
                        background-position: 10px 5px;
                    }
                    &#menu_kit_filtres{
                        background-image: url(../assets/icons/Icone_Kit_Filtres.svg);
                    }
                    &#menu_portes_filtres{
                        background-image: url(../assets/icons/Icone_Porte_Filtre.svg);
                        background-position: 10px 5px;
                    }
                    &#menu_clipin{
                        background-image: url(../assets/icons/Icone_Clipin.svg);
                        background-position: 4px 5px;
                    }
                    &#menu_accessoires{
                        background-image: url(../assets/icons/Icone_Accessoires.svg);
                        background-position: 10px 5px;
                    }
                    &#menu_smartphone{
                        background-image: url(../assets/icons/Icone_Smartphone.svg);
                        background-position: 10px 5px;
                    }
                    */
                    & ul{
                        padding-top: 10px;
                        li{
                            padding: 0;
                            padding-top: 5px;
                            font-weight: 400;
                            text-decoration: none;
                            text-transform: none;
                            a{
                                text-decoration: none;
                                &:hover, &.router-link-active{
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                }
            }
            &:hover, &.open {
                &>a:after{
                    transform: rotate(90deg);
                }
                &>ul{
                    max-height: 600px;
                    z-index: 102;
                }
            }
        }
        a{
            display: inline-block;
            position: relative;
            color: #000;
        }
    }
}
@media only screen and (min-width : $responsive-point) {
    ul.nav{
        padding-left: 0;
        margin-top: 0;
        //position: relative;
        align-self: flex-end;
        &:hover > li a.router-link-active{
            border-bottom-color: transparent;
            &:hover{
                border-bottom-color: #DC0303;
            }
        }
        &>li{
            margin-top:0;
            text-transform: none;
            display: inline-block;
            font-weight: 400;
            font-size: 14px;
            line-height: 40px;
            margin-right: 30px;
            a{
                text-decoration: none;
                border-bottom: 5px solid transparent;
                &.router-link-active, &:hover{
                    border-bottom: 5px solid #DC0303;
                }
            }
            &:hover a{
                border-bottom: 5px solid #DC0303;
            }
            &.parent a::after{
                content: '';
            }
            &.parent>ul{
                position: absolute;
                //position: fixed;
                //top: 138px;
                top: 100%;
                //left: calc((100vw - 1024px) / 2);
                left: 0;

                width: 1024px;
                background-color: #FAFAFA;
                padding-top: 38px 0;
                display: flex;
                flex-wrap: wrap;
                z-index: -1;
                // we display a shadow under the menu but not at the top
                box-shadow: 0px 8px 8px 0px #00000040;
                &>li{
                    width: calc(100% / 3);
                    margin-right: 0;
                    background-position: 10px 50px;
                    padding-left: 100px;
                    background-size: 84px auto;
                    min-height: 200px;
                    position: relative;
                    padding-bottom: 40px;
                    &:nth-child(1):before{
                        border-bottom: 1px solid #B4B4B4;
                        content:'';
                        height: 1px;
                        width: calc(300% - 20px);
                        position: absolute;
                        bottom: 0;
                        left: 10px;
                    }
                    &:nth-child(3n+1):after,&:nth-child(3n+2):after{
                        content:'';
                        position: absolute;
                        background-color: #B4B4B4;
                        width: 1px;
                        height: calc(100% - 60px);
                        top: 30px;
                        right: 0;
                    }
                    &>a, &:hover>a{
                        text-decoration: underline;
                        border-bottom: none !important;
                        font-weight: bold;
                        text-transform: uppercase;
                        font-size: 14px;
                        line-height: 17px;
                    }
                    &.parent>ul{
                        display: block;
                        max-height: 100%;
                        &>li{
                            padding-top: 0;
                            line-height: 22px !important;
                            font-size: 14px;
                            &>a{
                                border-bottom: none !important;
                            }
                            
                        }
                    }
                }
            }
        }
    }
}
</style>